import { gql } from "@apollo/client";



export const CREATE_COMPENSATION = gql`
  mutation createCompensation($input: [createCompensationInput]) {
    createCompensation(input: $input) {
      created {
        employeeId
        effectiveDate
        effectivePeriod
        ctc
        status
      }
      existing {
        employeeId
        effectiveDate
        effectivePeriod
        ctc
        status
      }
    }
  }
`;
export const CREATE_US_COMPENSATION = gql`
  mutation CreateUSCompensation($input: createCompensationUSInput) {
    createUSCompensation(input: $input) {
      id
      employeeId
    }
  }
`;

export const UPDATE_COMPENSATION = gql`
  mutation updateCompensation($input: updateCompensationInput) {
    updateCompensation(input: $input)
  }
`;

export const UPDATE_US_COMPENSATION = gql`
  mutation UpdateUSCompensation($input: updateCompensationUSInput) {
    updateUSCompensation(input: $input)
  }
`;



export const GET_USERBY_COMPENSATION = gql`
  query compensationByUser($employeeId: String!) {
    compensationByUser(employeeId: $employeeId) {
      effectiveDate
      effectivePeriod
      ctc
      basicSalary
      hra
      ltaAllowance
      otherAllowance
      variablePay
      professionalTax
      medicalInsurance
      pf
      totalDeductions
      netPayable
      employerPF
      nps
      voluntaryPF
      employeeId
      fixedPay
      id
      effectiveFlag
      salaryTemplateId
      employerESI
      employeeESI
    }
  }
`;
export const GET_USERBY_COMPENSATION_US = gql`
  query USCompensationByUser($employeeId: String) {
    USCompensationByUser(employeeId: $employeeId) {
      id
      employeeId
      effectiveDate
      effectivePeriod
      hourlyRate
      grossPay
      salaryTemplateId
    }
  }
`;





export const DELETE_COMPENSATION = gql`
  mutation DeleteCompensation($id: Int) {
    deleteCompensation(id: $id)
  }
`;
export const CREATE_IND_SINGLE_COMPENSATION = gql`
  mutation CreateIndSingleCompensation($input: createCompensationInput) {
    createIndSingleCompensation(input: $input) {
      message
      status
      data {
        id
      }
    }
  }
`;
export const UPDATE_IND_SINGLE_COMPENSATION = gql`
  mutation UpdateIndSingleCompensation($input: updateCompensationInput) {
    updateIndSingleCompensation(input: $input) {
      data {
        id
      }
      message
      status
    }
  }
`;
